import i18n from '@/lang/i18n'

export default [
  {
    path: '/admin/apply/saas_agent/api_key/list',
    name: 'saasAgentApiKey',
    component: () => import('@/views/apply/saas_agent/api_key/index.vue'),
    meta: {
      title: i18n.t('saas_agent.api_key_manage'),
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/saas_agent/agent/list',
    name: 'saasAgentList',
    component: () => import('@/views/apply/saas_agent/agent/index.vue'),
    meta: {
      title: i18n.t('saas_agent.agent_manage'),
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/saas_agent/skill/list',
    name: 'saasAgentSkillList',
    component: () => import('@/views/apply/saas_agent/skill/index.vue'),
    meta: {
      title: i18n.t('saas_agent.skill_manage'),
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/saas_agent/knowledge/list',
    name: 'saasAgentKnowledgeList',
    component: () => import('@/views/apply/saas_agent/knowledge/index.vue'),
    meta: {
      title: i18n.t('saas_agent.knowledge_manage'),
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/saas_agent/log/list',
    name: 'saasAgentLogList',
    component: () => import('@/views/apply/saas_agent/log/index.vue'), // Token usage logs
    meta: {
      title: i18n.t('saas_agent.log_manage'),
      headType: 0,
      auth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/apply/saas_agent.js